import { render, staticRenderFns } from "./ModifyDetails.vue?vue&type=template&id=127bb856&"
import script from "./ModifyDetails.vue?vue&type=script&lang=js&"
export * from "./ModifyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VDataIterator,VPagination})
